import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import coupleImage from '../../../assets/images/couples/Vector.png';
import { SignupContext } from '../../../context/SignupContext';

const Description = () => {
    // Form data state

    const navigate = useNavigate();

    const { userName, userId, isLoggedIn } = useContext(SignupContext);

    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        description: ""
    });

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch all dropdown options
    useEffect(() => {
        // if(!isLoggedIn){
        //   navigate('/sign-up');
        // }
        setIsLoading(false);
    }, []);



    const validateForm = () => {
        /////after Fill Validate form
        const newErrors = {};
        if (!formData.description) newErrors.description = "Description is Required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (!validateForm()) return;


        navigate("/desired-partner/");

        // try {
        //     const payload = new FormData();

        //     payload.append("user_id", userId);
        //     payload.append("age", `${formData.min_age.value},${formData.max_age.value}`);
        //     payload.append("height", `${formData.min_height.value},${formData.max_height.value}`);
        //     payload.append("ms", Object.values(formData.maritalStatus.map((val, i) => ((i == 0) ? (val.value) : (`${val.value}`)))));
        //     payload.append("country", formData.country.label);
        //     payload.append("state", Object.values(formData.state.map((val, i) => ((i == 0) ? (val.label) : (`${val.label}`)))));
        //     payload.append("caste", Object.values(formData.caste.map((val, i) => ((i == 0) ? (val.value) : (`${val.value}`)))));
        //     payload.append("motherTongue", Object.values(formData.language.map((val, i) => ((i == 0) ? (val.value) : (`${val.value}`)))));
        //     payload.append("h_education", formData.highestEducation.value);
        //     payload.append("occupation", Object.values(formData.occupation.map((val, i) => ((i == 0) ? (val.value) : (`${val.value}`)))));
        //     payload.append("income", formData.income.value);


        //     const response = await axios.post(
        //         `${process.env.REACT_APP_API_BASE_URL}/Register_controller/insertDesiredPartner`,
        //         payload
        //     );

        //     if (response.data.status) {
        //         ///use context api 
        //         // setUserId(response.data.id);
        //         navigate('/profile-success');
        //     }

        // } catch (error) {
        //     console.log('Error While Posting Data:', error);
        // }
    };




    if (isLoading) {
        return <div className='custom-loader-g'>
            <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    return (



        <>

            <div className='py-md-5'></div>


            <div className='create-profile-wrapper'>

                <div className='container'>
                    <div className="create-profile-container">
                        {/* Left Side Form */}
                        <div className="create-profile-form-side">
                            <h1 className="create-profile-heading text-center mb-0">Desired Partner Profile</h1>
                            {/* <p className="create-profile-subheading text-center">Start your journey here</p> */}

                            <form className="create-profile-form" onSubmit={handleSubmit}>
                                {/* Section 1: Basic Details */}
                                <h3 className="form-section-title text-center mb-0">Basic Details</h3>

                                <textarea rows={10}>data </textarea>

                                <button type="submit" className="create-btn mt-3">Submit</button>
                            </form>
                        </div>

                        {/* Right Side Image */}
                        <div className="create-profile-image-side d-none d-lg-block">
                            <img src={coupleImage} alt="Couple" className="couple-image" />
                            <div className="image-overlay">
                                <h2 className="overlay-heading">
                                    Your Journey To Love Begins <span className="highlight">Here!</span>
                                </h2>
                                <p className="overlay-text">
                                    Connect With Genuine Matches Who Share Your <span className="highlight">Values</span> And <span className="highlight">Dreams</span>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <style>
                    {`
        /* Main Layout */


          .coloashe{
        color:red;}   

        .form-group select,.form-group input
        {
        background:white;
        border-radius:15px;
        }
        .create-profile-wrapper {
          min-height: 100vh;
          background-color: #fff;
        }

        .create-profile-logo {
          max-width: 180px;
          margin: 20px;
        }

        .create-profile-container {
          display: flex;
          height: calc(100vh - 80px);
          overflow: hidden;
          border-radius:16px;
          box-shadow:0 10px 30px rgba(0, 0, 0, 0.08);
          margin-top:30px;
        }

        /* Form Side Styles */
        .create-profile-form-side {
        gap:3px 1.5rem;
          width: 60%;
          padding: 40px;
          overflow-y: auto;
          background-color: #fff;
        }

        .create-profile-heading {
          font-size: 2rem;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .create-profile-subheading {
          color: #666;
          margin-bottom: 0;
          font-size: 1rem;
        }

        .create-profile-form {
          display: flex;
          flex-direction: column;
        }

        .form-section-title {
          color: #E53D5C;
          font-size: 1.3rem;
          font-weight: 600;
        }

        /* Form Elements */
        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 0.8rem;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 1rem;
          transition: border-color 0.2s;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #E53D5C;
        }

        .form-textarea {
          min-height: 100px;
          resize: vertical;
        }

        .form-row {
          display: flex;
          gap: 1.5rem;
        }

        .form-row > .form-group {
          flex: 1;
        }

        /* Image Side Styles */
        .create-profile-image-side {
          width: 40%;
          position: relative;
          // background-color: #F8E1E7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        
        }

        .couple-image {
             width: 100%;
    height: 100%;
    border-radius:16px;
        }

        .image-overlay {
          text-align: center;
          
          
    max-width: 100%;
    position: absolute;
    bottom: 40px;
    padding:20px;
}
        

        .overlay-heading {
          
          
          
          


              font-size: 28.8px;
    color: white;
    line-height: 1.3;
    font-weight: 700;
    line-height: 1.4;
    margin-bottom: 12px;
        }

        .overlay-text {
          font-size: 1rem;
          
          



          line-height: 1.6;
    color: white;
    font-weight: bold;
        }

        .highlight {
          color: #ffc107;
          font-weight: 600;
        }

        .create-btn {
          padding: 12px;
          background-color: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          margin-top: 2rem;
        }

        .loading, .error {
          padding: 2rem;
          text-align: center;
          font-size: 1.2rem;
        }

        .error {
          color: #E53D5C;
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .create-profile-container {
            flex-direction: column;
            height: auto;
            padding:15px;
          }
          
          .create-profile-form-side,
          .create-profile-image-side {
            width: 100%;
                    padding: 0px;
        padding-top: 110px;
          }
          
          .form-row {
            flex-direction: column;
            gap:0 1rem;
          }
            .css-13cymwt-control {
            border-color: #dee2e6 !important ;
            }
          .css-13cymwt-control:hover {
            border-color: #dee2e6 !important ;
            }
        }
        `}
                </style>
            </div>
        </>
    );
};

export default Description;